module.exports = __webpack_public_path__ + "media/images/top/feature/top-features-1-a8e5327ad0147b71dc1c68d87da88b5a.png";